// Global constants used by other theme scripts
// eslint-disable-next-line no-unused-vars
const ON_CHANGE_DEBOUNCE_TIMER = 300;

// eslint-disable-next-line no-unused-vars
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
